export const classes = {
  drawer: 'w-[80vw] max-w-[250px] p-4',
  link: 'my-3',
};
